// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XhJD","right":"styles_right__1Dv7i"};